import React from 'react';
import generalManagerImg from '../Img/general-manager.jpg';

const AboutUs = () => {
  return (
    <section className="about-container">
        <div className="about-header">
        <h1>About Ora Group</h1>
        <p>
          R.N. Auto Pvt. Ltd., incorporated in August 2016 in India and headquartered at Thakur Complex, Mumbai – 400101, focuses on designing and manufacturing electric vehicles and related technologies such as batteries, charging infrastructure, and software. The company's key elements include its history, market position, product offerings (including scooters, bikes, cargo vehicles, and three-wheeler autos), technological innovations, funding, and sustainability initiatives.
        </p>
        <p>
          Market Position: Defines whether the company is a leader in the mass market, the premium segment, or a niche area. Ecosystem & Infrastructure: Covers involvement in developing supporting systems such as charging networks, battery swapping solutions, and servicing facilities. Sustainability & Mission: Highlights the company’s commitment to reducing emissions, promoting a greener planet, and driving economic progress through clean mobility.
        </p>
      </div>

      <div className="about-section">
        <h2>Our Products</h2>
        <p>
          Ora Group offers a wide range of electric vehicles, including:
        </p>
        <ul>
          <li>4 Models of E-Rickshaws – Designed for efficient public transport in urban and rural areas.</li>
          <li>2 Models of E-Loaders – Ideal for goods delivery and logistics support.</li>
          <li>4 Models of E-Scooters – Stylish, comfortable, and perfect for daily commuting.</li>
        </ul>
        <p>
          Each product is engineered with high-quality materials and tested to withstand Indian road conditions.
        </p>
      </div>

      <div className="about-section">
        <h2>Mission</h2>
        <p>
          Our mission is to lead the transition to sustainable mobility by delivering reliable, cost-effective, and environment-friendly electric vehicles.
          We are committed to innovation, customer satisfaction, and contributing to a pollution-free India.
        </p>
      </div>

      <div className="about-section">
        <h2>Vision</h2>
        <p>
          We envision a future where the name <strong>ORA EVEE BIKE</strong> becomes synonymous with green transportation across India.
          Our goals include:
        </p>
        <ul>
          <li>Setting new standards in quality and service every day.</li>
          <li>Gaining customer trust through excellent performance and support.</li>
          <li>Empowering our network of employees, dealers, and partners.</li>
          <li>Building a sustainable future through continuous innovation and ethical practices.</li>
        </ul>
      </div>

      <div className="about-section">
        <h2>Company Presence</h2>
        <p>
        Since 2022, Ora Group has established operations in Delhi. To strengthen our presence in Western and Southern India, we opened a regional head office in Mumbai and set up a manufacturing unit and warehouse in Ahilyabai Nagar, Maharashtra.
        </p>
      </div>

      <div className="about-section">
        <h2>Our Leadership Team</h2>
        <p><strong>Director:</strong> Rupesh Ramesh Shukla</p>
        <p><strong>General Manager:</strong> Ramesh Bhagwati Shukla</p>
        <p><strong>Sales Director:</strong> Vijay Mishra</p>
      </div>

      <div className="about-section about-director-section">
        <h2>Director of Sales</h2>
        <div className="about-director-content">
          <img
            src={generalManagerImg}
            alt="Vijay Mishra, Director of Sales"
            className="about-director-image"
          />
          <div className="about-director-text">
            <p>
              I am Vijay Mishra, Director of Sales. We serve the marketing sector across India, focusing on building strong, reliable, and long-term business partnerships. Supporting and ensuring the complete satisfaction of all our business partners is our primary responsibility. We believe in maintaining transparency, trust, and excellence in every business relationship. You can reach us at <strong>9654370655</strong>. Our goal is to maintain 100% positive business relations throughout India by delivering consistent support and creating valuable partnerships.
            </p>
          </div>
        </div>
      </div>

      <div className="about-section">
        <h2>Dealer Network</h2>
        <p>
          Ora Group continues to grow its national presence with a strong and trusted dealer network across India. Our current active dealership locations include:
        </p>
        <ul>
          <li>Bihar – 3 Dealers</li>
          <li>Uttar Pradesh – 2 Dealers</li>
          <li>Maharashtra – 4 Dealers</li>
          <li>Odisha – 1 Dealer</li>
          <li>Karnataka – 2 Dealers</li>
          <li>Gujarat – 1 Dealer</li>
          <li>West Bengal – 2 Dealers</li>
          <li>Madhya Pradesh – 5 Dealers</li>
          <li>Rajasthan – 3 Dealers</li>
        </ul>
        <p>
          We are continuously expanding to ensure better accessibility, service, and product availability across all corners of the country.
        </p>
      </div>


      <div className="about-footer">
        <p>
          Ora Group is not just manufacturing vehicles; we are creating a greener future for generations to come.
          Join us in driving India towards sustainable, clean mobility.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
